import React, {useEffect, useState} from "react";

interface ShakingTextCharProps{
    offset:number;
}

const ShakingTextChar:React.FC<ShakingTextCharProps> = (props) => {
    const [x,setX] = useState(0);
    const [y,setY] = useState(0);
    const [s,setS] = useState(1.0);
    const [isCensored,setIsCensored] = useState(false);
    const move = 12.0;
    const scale = 0.125;
    useEffect(() => {
        setInterval(() => {
            //setX(x+Math.random()*move*2.0-move);
            // setY(y+Math.random()*move*2.0-move);
            // setS(Math.random()*scale+(1.0 - scale));
            setY(Math.sin((props.offset*1000.0-Date.now())/1000.0*3.14)*move*2.0-move);
            setIsCensored(Math.random() < 0.0);
        },10)
    },[]);
    return(
        <div style={{transform:`scale(${s},${s}) translate(${x}px,${y}px)`,transition:"all 0.2s"}}>
            {isCensored ? "■" : props.children}
        </div>
    )
}

export default ShakingTextChar;